//dependencias
import React, { Component } from 'react';

//componentes
import SeccionesAction from './secciones'

class Index extends Component {

    render(){
        return(
            <div>
                <SeccionesAction />
            </div>
        );
    }

}
export default Index;